import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiHelper } from "../utils/apiHelper";

const initialState = {
    token: '',
    tempToken: '',
    isLogged: false,
    loading: true, 
    user: {},
    authorities: []
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setToken(state, action) {
            state.token = action.payload || '';
            state.isLogged = !!action.payload; 
            state.loading = false; 
        },
        setTempToken(state, action) {
            state.tempToken = action.payload;
        },
        setUser(state, action) {
            state.user = action.payload || {};
        },
        setAuthorities(state, action) {
            state.authorities = action.payload || [];
        },
        setLoading(state, action) {
            state.loading = action.payload; 
        },
        logout(state) {
            state.token = '';
            state.tempToken = '';
            state.isLogged = false;
            state.loading = false;
            state.user = {};
            state.authorities = [];
        }
    },
});

export const { setToken, setTempToken, setUser, setAuthorities, setLoading } = authSlice.actions;

export const registerIndividual = createAsyncThunk(
    'auth/registerIndividual',
    async (userData, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.post('/register/individual', userData);
            if (response.data.code === "00000") {
                return response.data;
            } else {
                throw new Error(response.data.message || "Kayıt işlemi başarısız oldu");
            }
        } catch (error) {
            return rejectWithValue(error.message || "Bir hata oluştu");
        }
    }
);

export const registerCorporate = createAsyncThunk(
    'auth/registerCorporate',
    async (userData, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.post('/register/corporate', userData);
            if (response.data.code === "00000") {
                return response.data;
            } else {
                throw new Error(response.data.message || "Kayıt işlemi başarısız oldu");
            }
        } catch (error) {
            return rejectWithValue(error.message || "Bir hata oluştu");
        }
    }
);

export default authSlice.reducer;